module.exports = __webpack_public_path__ + "assets/img/a20a9d5c95e8e669543673bd13682f83.svg";